import rawApi from './raw-api.interface';
import sdkApi from './sdk-api.interface';
export var RawApi = rawApi;
export var SDKApi = sdkApi;
export default {
  RawApi: RawApi,
  SDKApi: SDKApi
};